export const sanitizeCityName = (name: string) => {
  return name.replace('á', 'a')
}
